import React from 'react'

import View from './View.jsx'

const Container = ({ admData }) => {
  return <View title="Lista Clientes" admData={admData} />
}

export default Container
